import React from 'react';

import {hot} from 'react-hot-loader/root';
import AppScreen from './routes/index';


function App(){
    return (
        <AppScreen />
    )
}

export default hot(App);